import React from 'react';
import { connect } from 'react-redux';
import findResult, { findSelected } from '@/utils/resultsHelper';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import { removeCollectionDatasets, showAddCollectionDatasets } from '../datasets/actions';

const AssignCollectionAction = ({
  category,
  code,
  name,
  results,
  disableAdd,
  disableRemove,
  showAddDataset,
  removeDatasets,
}) => (
  <>
    <RibbonMenu
      name="add-collection-dataset"
      icon="plus"
      disabled={disableAdd}
      message="actions.add"
      titleMessage="actions.collection.datasets.add"
      onClick={() => showAddDataset(category, code, name)}
      className="aridhia-manage-collection-action"
    />
    <RibbonMenu
      name="remove-collection-dataset"
      icon="minus"
      disabled={disableRemove}
      message="actions.remove"
      titleMessage="actions.collection.datasets.remove"
      onClick={() => removeDatasets(category, code, results)}
      className="aridhia-manage-collection-action"
    />
  </>
);

const mapStateToProps = ({
  collectionDatasets: { collectionDatasets },
}, { category, code }) => {
  const datasetCollection = findResult(collectionDatasets, category, code);
  const results = datasetCollection ? findSelected(datasetCollection.results, true) : [];

  return {
    results,
    name: datasetCollection?.name,
  };
};

const mapDispatchToProps = {
  showAddDataset: showAddCollectionDatasets,
  removeDatasets: removeCollectionDatasets,
};

export default connect(mapStateToProps, mapDispatchToProps)(AssignCollectionAction);
